import UserCompGrid from 'components/User/UserCompGrid'
import useFetch from 'hooks/useFetch'
import { useEffect } from 'react'
import { toast } from 'react-toastify'

export default function UserViewGrid() {
  // useFetch(): hooks personalizados para realizar solicitudes GET, POST, PUT, DELETE.
  const [fetchedUsers, fetchUsers] = useFetch()
  const [deletedUser, deleteUser] = useFetch()

  // TEST FAKER (Código comentado para guardar datos de prueba)
  // const [data, setData] = useState(null)

  // CRUD: GET (Recoger datos de los usuarios con la API)
  useEffect(() => {
    const apiCallGet = {
      url: 'users',
      method: 'GET',
      messageKo: 'Error carregant usuario!'
    }
    fetchUsers(apiCallGet) // Llama a la función del hook personalizado para realizar la solicitud GET

    // TEST FAKER (Código comentado para generar datos de prueba)
    // const peopleArray = []

    // for (let i = 0; i < 162; i++) {
    //   const newObject = {
    //     Id: i + 1,
    //     UserName: faker.internet.email(),
    //     Name: faker.person.fullName(),
    //     Password: '123',
    //     Email: faker.internet.email()
    //   }
    //   console.log('🚀 ~ useEffect ~ newObject:', newObject)

    //   peopleArray.push(newObject)
    // }

    // setData(peopleArray)
  }, []) // Este useEffect se ejecutará una vez al principio y en cada renderización del componente

  // CRUD: DELETE (Eliminar un usuario)
  const handleDelete = async (id) => {
    const apiCallDelete = {
      url: `users/${id}`,
      method: 'DELETE'
    }
    await deleteUser(apiCallDelete) // Llama al hook deleteUser con los parámetros definidos
  }

  // Mostrar mensaje API: DELETE (Muestra notificación de éxito o error)
  useEffect(() => {
    // Si la solicitud DELETE ha sido realizada
    if (deletedUser.isCalled) {
      // Función para mostrar un mensaje de éxito
      const successMessage = (message) =>
        toast.success(message, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light'
        })

      // Función para mostrar un mensaje de error
      const errorMessage = (error) =>
        toast.error(error, {
          position: 'top-center',
          autoClose: 5000,
          closeOnClick: false,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: 'light'
        })

      // Si hay un mensaje de éxito en la respuesta de DELETE
      if (deletedUser.message) {
        successMessage(deletedUser.message)

        const apiCallGet = {
          url: 'users',
          method: 'GET',
          messageKo: 'Error carregant usuaris!'
        }
        fetchUsers(apiCallGet) // Llama a la función del hook personalizado para realizar la solicitud GET
      }

      // Si hay un mensaje de error en la respuesta de DELETE
      if (deletedUser.error) {
        errorMessage(deletedUser.error)
      }
    }
  }, [deletedUser.loading]) // Este useEffect se ejecutará cada vez que 'deletedUser.loading' cambie

  // Si se han cargado los usuarios, muestra el grid de usuarios
  return (
    <>
      <UserCompGrid items={fetchedUsers?.data} handleDelete={handleDelete} />

      {/* TEST FAKER (Código comentado para mostrar datos de prueba) */}
      {/* <UserCompGrid items={data} handleClick={handleClick} /> */}
    </>
  )
}
